import React from "react";
import "./VideoSection.css";
import DemoVideo from "../../assets/video/demo-video.mp4";
function VideoSection() {
  return (
    // <section className="video-wrap">
    //   <div className="video-inner">
    //     <video autoPlay muted>
    //       <source src={DemoVideo} type="video/mp4" />
    //     </video>
    //   </div>
    // </section>
    <div></div>
  );
}

export default VideoSection;
